"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const unexpected_client_error_1 = require("../errors/unexpected.client.error");
const client_error_1 = require("../errors/client.error");
const timezone_transform_payload_1 = require("./utils/timezone-transform-payload");
class BaseClient {
    constructor(config) {
        this.formatDateWithTimezone = false;
        this.configurationProvider = config;
    }
    getConfig() {
        return this.configurationProvider.getConfiguration();
    }
    httpGet(path, opts = { throwOnError: true }) {
        return this.executeCall('get', path, null, opts);
    }
    httpPut(path, data, opts = { throwOnError: true }) {
        return this.executeCall('put', path, data, opts);
    }
    httpPost(path, data, opts = { throwOnError: true }) {
        return this.executeCall('post', path, data, opts);
    }
    httpDelete(path, opts = { throwOnError: true }) {
        return this.executeCall('delete', path, null, opts);
    }
    executeRaw(method, path, data, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosOpts = opts || {};
            const axiosResponse = (yield this.executeCall(method, path, data, Object.assign(Object.assign({}, axiosOpts), { responseType: 'arraybuffer' })));
            if (axiosResponse.status > 299) {
                throw new client_error_1.ClientError({
                    success: false,
                    errorMessage: 'Binary response error',
                    errorCode: 'UNKNOWN_ERROR',
                });
            }
            return axiosResponse;
        });
    }
    executeCall(method, path, data, opts) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(this.getDefaultHeaders(!!data), (_a = opts) === null || _a === void 0 ? void 0 : _a.headers);
            const timeout = 30000;
            if (this.formatDateWithTimezone && data) {
                data = timezone_transform_payload_1.timezoneTransformPayload(data);
            }
            const config = yield this.getConfig();
            const url = config.url + path;
            config.logger.log(`${method.toUpperCase()} ${url} ${JSON.stringify(data)}`);
            const responsePromise = axios_1.default.request(Object.assign(Object.assign({}, opts), { method,
                url,
                data,
                headers,
                timeout, validateStatus: () => true }));
            let axiosResponse;
            try {
                axiosResponse = yield responsePromise;
                if (opts.responseCookies) {
                    const setCookie = require('set-cookie-parser');
                    const cookies = setCookie.parse(axiosResponse);
                    for (const cookie of cookies) {
                        opts.responseCookies.set(cookie.name, cookie);
                    }
                }
            }
            catch (e) {
                config.logger.error(`${method.toUpperCase()} ${url}`);
                config.logger.error(e);
                throw new unexpected_client_error_1.UnexpectedClientError(e.message);
            }
            const contentType = axiosResponse.headers['content-type'] || '';
            if (!contentType.includes('application/json') ||
                (contentType.includes('application/json') && opts.responseType === 'arraybuffer')) {
                return axiosResponse;
            }
            if (axiosResponse.status === 404 && opts.returnNullOn404) {
                return { success: true };
            }
            const response = axiosResponse.data;
            if (!response.success) {
                config.logger.error(`${method.toUpperCase()} ${url}`, JSON.stringify(response));
                if (opts.throwOnError == null || opts.throwOnError) {
                    throw new client_error_1.ClientError(response);
                }
                return response;
            }
            return response;
        });
    }
    getQueryString(params) {
        return Object.entries(params)
            .filter(e => e[1] !== undefined && e[1] !== null)
            .reduce((query, e) => query + `${e[0]}=${this.encodeValue(e[1])}&`, '');
    }
    encodeValue(value) {
        if (value instanceof Date) {
            return value.toISOString();
        }
        if (value instanceof Array) {
            return value.map(i => this.encodeValue(i)).join(',');
        }
        return encodeURIComponent(value);
    }
    getDefaultHeaders(withBody) {
        return Object.assign({ 'x-request-id': this.getConfig().requestIdProvider(), 'x-request-from': this.getConfig().requestFromProvider(), 'x-request-from-version': this.getConfig().requestFromVersionProvider(), 'x-request-tags': serializeTags(this.getConfig().requestTagsProvider()) }, (withBody && { 'content-type': 'application/json' }));
    }
}
exports.BaseClient = BaseClient;
function serializeTags(tags) {
    if (!tags) {
        return '';
    }
    return Object.entries(tags)
        .map(entry => {
        const [key, value] = entry;
        return `${key}=${value}`;
    })
        .join(',');
}
//# sourceMappingURL=base.client.js.map